import script from "./CustomerSubscriptionPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerSubscriptionPage.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerSubscriptionPage.vue?vue&type=style&index=0&id=6662c9ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6662c9ec"]])

export default __exports__